// extracted by mini-css-extract-plugin
export default {"modalHeader":"Modal_modalHeader__yVoQ7","modalContent":"Modal_modalContent__F+dDV","modalTitle":"Modal_modalTitle__s7xzq","closeButton":"Modal_closeButton__7vu9X"};